export default "__VITE_ASSET__BLGgLcVt__"